export default "__VITE_ASSET__BbS0beKo__"